export function formatINR(amount) {
  const n = Number(amount || 0);
  return "₹" + n.toLocaleString("en-IN", { maximumFractionDigits: 0 });
}

export function discountPercent(mrp, price) {
  if (!mrp || mrp <= price) return 0;
  return Math.round(((mrp - price) / mrp) * 100);
}

export function directionsUrl(b) {
  if (!b) return "https://www.google.com/maps";
  const q = [b.name, b.address, b.city, b.state, b.pincode].filter(Boolean).join(", ");
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}

export function waLink(number) {
  return `https://wa.me/${String(number || "").replace(/\D/g, "")}`;
}
